export default __webpack_public_path__ + "static/media/movil.d3ae2bad.png";